<template>
  <v-container fill-height>
    <v-row class="fill-height" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="5" lg="4" xl="3">
        <df-messenger
          location="us-central1"
          project-id="balcao-virtual-default"
          :agent-id="_agentID"
          language-code="pt-br"
          max-query-length="-1"
        >
          <!-- agente está sendo usado o do balcao-default -->
          <v-btn
            class="text-none text-body-2 font-weight-bold mt-2"
            color="red"
            outlined
            elevation="1"
            absolute
            top
            right
            small
            style="z-index: 9999"
            @click="handleFinalize"
          >
            <v-icon small class="mr-1">mdi-phone-remove</v-icon> Finalizar
          </v-btn>
          <df-messenger-chat
            :chat-icon="require('@/assets/mini_logo.png')"
            chat-title="Balcão Virtual"
            placeholder-text="Digite sua mensagem aqui"
            :bot-actor-image="require('@/assets/mini_logo.png')"
            :chat-title-icon="require('@/assets/mini_logo.png')"
          >
          </df-messenger-chat>
        </df-messenger>
      </v-col>
    </v-row>

    <v-dialog v-model="finalizeDialog" max-width="400">
      <v-card>
        <v-card-title>Confirmar Finalização</v-card-title>
        <v-card-text
          >Tem certeza que deseja finalizar o atendimento?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-none" plain @click="finalizeDialog = false">
            Cancelar
          </v-btn>
          <v-btn class="text-none" color="primary" @click="finalize">
            Finalizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="payloadModal"
      max-width="500"
      style="z-index: 99999"
      persistent
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :retain-focus="false"
      :content-class="$vuetify.breakpoint.smAndDown ? 'mobile-dialog' : ''"
    >
      <v-card class="mobile-modal-card">
        <v-card-title class="mobile-modal-title">{{
          payloadData.title
        }}</v-card-title>
        <v-card-text class="select-container mobile-modal-content">
          <template v-if="payloadData.type === 'comarca'">
            <ItemSelector
              v-model="selectedOptions.comarca"
              :items="selectors.groups.items"
              :label="`Selecionar ${$t('groups')}`"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              :count="selectors.groups.count"
              :loading="selectors.groups.loading"
              :disabled="false"
              :required="true"
              :clearable="true"
              item-text="text"
              :item-value="selectors.groups.selected?._id"
              :placeholder="`Digite para buscar ${$t('groups')}...`"
              @search="handleComarcaSearch"
              @paginate="loadMoreComarcas"
              ref="comarcaAutocomplete"
            />

            <ItemSelector
              v-model="selectedOptions.varas"
              :items="selectors.varas.items"
              :label="`Selecionar ${$t('subgroup')}`"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              :count="selectors.varas.count"
              :loading="selectors.varas.loading"
              :disabled="!selectedOptions.comarca"
              :required="true"
              :clearable="true"
              item-text="text"
              :item-value="selectors.varas.selected?._id"
              :placeholder="`Digite para buscar ${$t('subgroups')}...`"
              @search="handleVaraSearch"
              @paginate="loadMoreVaras"
              ref="varaAutocomplete"
            />

            <ItemSelector
              v-model="selectedOptions.desks"
              :items="selectors.desks.items"
              :label="`Selecionar ${$t('desk')}`"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              :count="selectors.desks.count"
              :loading="selectors.desks.loading"
              :disabled="!selectedOptions.varas"
              :required="true"
              :clearable="true"
              item-text="text"
              :item-value="selectors.desks.selected?._id"
              :placeholder="`Digite para buscar ${$t('desks')}...`"
              @search="handleDeskSearch"
              @paginate="loadMoreDesks"
              ref="deskAutocomplete"
            />
          </template>

          <template v-if="payloadData.type === 'cities'">
            <ItemSelector
              v-model="selectedOption"
              :items="selectors.cities.items"
              :label="payloadData.selectLabel || 'Selecionar'"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              :count="selectors.cities.count"
              :loading="selectors.cities.loading"
              :disabled="false"
              :required="true"
              :clearable="true"
              item-text="text"
              :item-value="selectors.cities.selected?._id"
              :placeholder="`Digite para buscar ${$t('groups')}...`"
              @search="handleCitySearch"
              @paginate="loadMoreCities"
            />
          </template>
        </v-card-text>
        <v-card-actions class="mobile-modal-actions">
          <v-spacer></v-spacer>
          <v-btn
            class="text-none"
            color="primary"
            :disabled="!isFormValid"
            @click="handlePayloadAction"
            >{{ payloadData.actionText || "Confirmar" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { handleFinishAttendance, handleAlert } from "@/utils";
import { mapActions, mapState } from "vuex";
import { getCourts } from "@/services/courts";
import { getCounters } from "@/services/counters";
import { updateAttendance } from "@/services/attendance";
import { getJurisdictions } from "@/services/jurisdictions";
import ItemSelector from "@/components/itemSelector/ItemSelector.vue";
// import { postInactive } from "@/services/inactive";

export default {
  name: "ChatCx",

  components: {
    ItemSelector,
  },

  data() {
    return {
      finalizeDialog: false,
      payloadModal: false,
      payloadData: {},
      selectedOption: null,
      selectedOptions: {
        comarca: null,
        varas: null,
        desks: null,
      },
      payloadMenssagem: "",
      comarcas: [],
      varas: [],
      desks: [],
      parametersCX: {},
      newAttendance: {},
      inactivityTimer: null,
      lastActivityTime: Date.now(),
      sessionId: null,
      readMode: false,
      selectors: {
        groups: {
          loading: false,
          items: [],
          selected: null,
          page: 0,
          count: 0,
          search: "",
        },
        varas: {
          loading: false,
          items: [],
          page: 0,
          count: 0,
          search: "",
        },
        desks: {
          loading: false,
          items: [],
          page: 0,
          count: 0,
          search: "",
        },
        cities: {
          loading: false,
          items: [],
          page: 0,
          count: 0,
          search: "",
        },
      },
    };
  },

  computed: {
    ...mapState("socket", [
      "attendance",
      "messages",
      "inQueue",
      "shouldClearStorage",
      "appointment",
    ]),
    ...mapState(["preSelection"]),
    isFormValid() {
      if (this.payloadData.type === "comarca") {
        return (
          this.selectedOptions.comarca &&
          this.selectedOptions.varas &&
          this.selectedOptions.desks
        );
      }
      return !!this.selectedOption;
    },
    _agentID() {
      return process.env.VUE_APP_AGENT_DF;
    },
  },

  watch: {
    inQueue(newValue) {
      if (newValue) {
        const isAppointmentQueue =
          this.appointment && this.appointment.autoScheduled === true;

        if (isAppointmentQueue && !this.appointment._id) {
          console.warn("Appointment ID not available in ChatCx");
          return;
        }

        const queuePath = isAppointmentQueue
          ? `/queue-appointments/${this.appointment._id}`
          : "/queue";

        if (this.$route.path !== queuePath) {
          this.$router.push({ path: queuePath });
        }
      }
    },
    shouldClearStorage(newValue) {
      if (newValue) {
        const dfMessenger = document.querySelector("df-messenger");
        if (dfMessenger && typeof dfMessenger.clearStorage === "function") {
          dfMessenger.clearStorage();
        }
        this.setShouldClearStorage(false);
      }
    },
    payloadModal(newValue) {
      if (newValue) {
        this.handleModalOpen();
      }
    },
    "selectedOptions.comarca": {
      handler(newValue) {
        if (newValue) {
          this.handleComarcaChange();
        }
      },
      deep: true,
    },
    "selectedOptions.varas": {
      handler(newValue) {
        if (newValue) {
          this.handleVaraChange();
        }
      },
      deep: true,
    },
  },

  created() {
    if (!this.attendance) {
      return this.$router.push({ path: "/home" });
    }
  },

  mounted() {
    console.log("mounted");

    if (this.shouldClearStorage || !this.messages?.length) {
      console.log("shouldClearStorage", this.shouldClearStorage);
      console.log("messages.length", !this.messages?.length);
      this.setupDfMessenger();
    }

    this.handleFetchGroups();
    this.setupPayloadListener();
  },

  beforeDestroy() {},

  methods: {
    handleFinalize() {
      this.finalizeDialog = true;
    },

    handleModalOpen() {
      if (this.payloadData.type === "cities" && this.payloadData.options) {
        this.selectors.cities.items = this.payloadData.options;
        this.selectors.cities.page = 0;
        this.selectors.cities.search = "";
        this.selectors.cities.count = this.payloadData.options.length;
      }
    },

    ...mapActions("socket", [
      "requestAttendance",
      "cancelAttendance",
      "setAttendance",
      "setInQueue",
      "dialogAttendance",
      "setMessages",
      "setShouldClearStorage",
    ]),

    setupDfMessenger() {
      let tryInitCount = 1;
      const tryInit = () => {
        console.log(`setupDfMessenger: tryInit (${tryInitCount++})`);
        const dfMessenger = document.querySelector("df-messenger");
        if (!dfMessenger)
          return console.log("setupDfMessenger: dfMessenger not found");

        const init = () => {
          try {
            dfMessenger.renderCustomText(
              "Olá, bem-vindo(a) ao nosso Balcão Virtual do TJPB. Como podemos te ajudar hoje?"
            );
            dfMessenger.renderCustomText("Qual o seu nome completo?");
          } catch (e) {
            console.error("Erro ao enviar mensagem:", e);
          }
        };

        console.log(
          "setupDfMessenger: if -> (this.shouldClearStorage || this.preSelection.groupID)",
          !!this.shouldClearStorage,
          !!this.preSelection.groupID
        );

        // limpa storage
        if (this.shouldClearStorage || this.preSelection.groupID) {
          dfMessenger.clearStorage?.();
          this.setShouldClearStorage(false);
        }

        // Se já carregou, executa direto
        if (dfMessenger.shadowRoot) {
          console.log("setupDfMessenger: dfMessenger.shadowRoot");
          init();
        } else {
          // Senão, escuta o evento
          console.log("setupDfMessenger: dfMessenger.addEventListener");
          dfMessenger.addEventListener("df-messenger-loaded", init, {
            once: true,
          });
        }

        return true;
      };

      // retry simples
      const interval = setInterval(() => {
        if (tryInit()) clearInterval(interval);
      }, 300);
    },

    async handleFetchGroups(search = "", increment = false) {
      this.selectors.groups.loading = true;

      try {
        const groupID = this.selectors.groups.selected?._id;

        const payload = {
          sortBy: "name",
          sortOrder: "asc",
          limit: 10,
          offset: this.selectors.groups.page * 10,
          ...(!!groupID && { nin: [groupID] }),
          ...(!!search?.length && { search }),
        };
        const {
          data,
          headers: { "x-count": count },
        } = await getJurisdictions(payload);

        this.selectors.groups.count = Number(count);

        const formattedData = data.map((comarca) => ({
          text: comarca.name,
          value: comarca._id,
        }));

        if (increment) {
          this.selectors.groups.items.push(...formattedData);
        } else {
          this.selectors.groups.items = formattedData;
        }

        return formattedData;
      } catch (error) {
        console.log("Falha ao obter", error);
        this.handleAlert(error?.data?.message || "Falha ao obter", "error");
        return [];
      } finally {
        this.selectors.groups.loading = false;
      }
    },

    handleComarcaSearch(search) {
      this.selectors.groups.search = search;
      this.selectors.groups.page = 0;

      this.handleFetchGroups(search, false);
    },

    async handleComarcaChange() {
      if (this.selectedOptions.comarca) {
        try {
          this.selectors.varas.items = [];
          this.selectors.varas.page = 0;
          this.selectors.varas.search = "";
          this.selectors.varas.count = 0;
          this.selectors.desks.items = [];
          this.selectors.desks.page = 0;
          this.selectors.desks.search = "";
          this.selectors.desks.count = 0;

          this.selectedOptions.varas = null;
          this.selectedOptions.desks = null;

          await this.handleFetchVaras("", false);
        } catch (error) {
          console.error("Erro ao buscar varas:", error);
        }
      }
    },

    async handleFetchVaras(search = "", increment = false) {
      this.selectors.varas.loading = true;

      try {
        const payload = {
          comarcaID: this.selectedOptions.comarca.value,
          limit: 10,
          offset: this.selectors.varas.page * 10,
          ...(!!search?.length && { search }),
        };
        const response = await getCourts(payload);

        const data = response.data.map((vara) => ({
          text: vara.name,
          value: vara._id,
        }));

        if (increment) {
          this.selectors.varas.items.push(...data);
        } else {
          this.selectors.varas.items = data;
        }

        this.selectors.varas.count =
          data.length +
          (increment ? this.selectors.varas.items.length - data.length : 0);

        return data;
      } catch (error) {
        console.error("Erro ao buscar:", error);
        this.handleAlert("Erro ao buscar. Tente novamente.", "error");
        return [];
      } finally {
        this.selectors.varas.loading = false;
      }
    },

    handleVaraSearch(search) {
      this.selectors.varas.search = search;
      this.selectors.varas.page = 0;
      this.handleFetchVaras(search, false);
    },

    async handleFetchDesks(search = "", increment = false) {
      this.selectors.desks.loading = true;

      try {
        const payload = {
          varaID: this.selectedOptions.varas.value,
          limit: 10,
          offset: this.selectors.desks.page * 10,
          ...(!!search?.length && { search }),
        };
        const response = await getCounters(payload);

        const data = response.data
          .filter((desk) => desk.isActive)
          .map((desk) => ({
            text: desk.name,
            value: desk._id,
          }));

        if (increment) {
          this.selectors.desks.items.push(...data);
        } else {
          this.selectors.desks.items = data;
        }

        this.selectors.desks.count =
          data.length +
          (increment ? this.selectors.desks.items.length - data.length : 0);

        return data;
      } catch (error) {
        console.error("Erro ao buscar balcões:", error);
        this.handleAlert("Erro ao buscar balcões. Tente novamente.", "error");
        return [];
      } finally {
        this.selectors.desks.loading = false;
      }
    },

    handleDeskSearch(search) {
      this.selectors.desks.search = search;
      this.selectors.desks.page = 0;
      this.handleFetchDesks(search, false);
    },

    handleDeskChange() {
      if (this.selectedOptions.desks) {
        this.selectedOptions.varas = null;
        this.selectors.varas.items = [];
        this.selectors.varas.page = 0;
        this.selectors.varas.search = "";
      }
    },

    handleCitySearch(search) {
      this.selectors.cities.search = search;
      this.selectors.cities.page = 0;
      this.handleFetchCities(search, false);
    },

    handleCityChange() {
      if (this.selectedOption) {
        this.selectedOptions.comarca = null;
        this.selectedOptions.varas = null;
        this.selectedOptions.desks = null;
        this.selectors.comarca.items = [];
        this.selectors.comarca.page = 0;
        this.selectors.comarca.search = "";
        this.selectors.varas.items = [];
        this.selectors.varas.page = 0;
        this.selectors.varas.search = "";
        this.selectors.desks.items = [];
        this.selectors.desks.page = 0;
        this.selectors.desks.search = "";
      }
    },

    handleFetchCities(search = "", increment = false) {
      this.selectors.cities.loading = true;

      try {
        let filteredCities = this.payloadData.options;

        if (search) {
          filteredCities = this.payloadData.options.filter((city) =>
            city.text.toLowerCase().includes(search.toLowerCase())
          );
        }

        const itemsPerPage = 10;
        const startIndex = this.selectors.cities.page * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedCities = filteredCities.slice(startIndex, endIndex);

        if (increment) {
          this.selectors.cities.items.push(...paginatedCities);
        } else {
          this.selectors.cities.items = paginatedCities;
        }

        this.selectors.cities.count = filteredCities.length;

        return paginatedCities;
      } catch (error) {
        console.error("Erro ao buscar:", error);
        return [];
      } finally {
        this.selectors.cities.loading = false;
      }
    },

    async setupPayloadListener() {
      window.addEventListener("df-response-received", async (event) => {
        this.parametersCX = event?.detail?.raw?.queryResult?.parameters;
        if (this.parametersCX && this.parametersCX.session) {
          this.sessionId = this.parametersCX.session.split("/sessions/")[1];
        }
        if (this.parametersCX?.finish) {
          this.finalize();
        }
        try {
          const payload =
            event?.detail?.raw?.queryResult?.responseMessages?.[0]?.payload
              ?.custom;
          if (payload?.comarcas) {
            if (
              this.preSelection?.deskID &&
              this.preSelection?.subgroupID &&
              this.preSelection?.groupID
            ) {
              this.handlePreSelection();
              return;
            } else {
              const comarcasData = await this.handleFetchGroups();

              this.payloadData = {
                type: "comarca",
                title: `Selecionar ${this.$t("desk")}`,
                options: {
                  comarca: comarcasData,
                  varas: [],
                  desks: [],
                },
                actionText: "Confirmar",
              };
              this.resetSelections();
              this.payloadModal = true;
            }
          } else if (payload?.cities) {
            this.payloadData = {
              type: "cities",
              title: `Selecionar ${this.$t("group")}`,
              options: payload.cities.map((city) => ({
                text: city.name,
                value: city.name,
              })),
              selectLabel: `Selecionar ${this.$t("group")}`,
              actionText: "Confirmar",
            };
            this.resetSelections();
            this.payloadModal = true;
          }
        } catch (error) {
          console.error("Erro ao processar resposta do Dialogflow:", error);
        }
      });
    },

    resetSelections() {
      this.selectedOption = null;
      this.selectedOptions = {
        comarca: null,
        varas: null,
        desks: null,
      };

      this.selectors.varas.items = [];
      this.selectors.varas.page = 0;
      this.selectors.varas.search = "";
      this.selectors.varas.count = 0;
      this.selectors.desks.items = [];
      this.selectors.desks.page = 0;
      this.selectors.desks.search = "";
      this.selectors.desks.count = 0;
      this.selectors.cities.items = [];
      this.selectors.cities.page = 0;
      this.selectors.cities.search = "";
      this.selectors.cities.count = 0;
    },

    closePayloadModal() {
      this.payloadModal = false;
      this.resetSelections();
      this.payloadData = {};
    },

    handlePayloadAction() {
      if (this.payloadData.type === "comarca") {
        this.handleCreateAttendance();
      } else {
        this.payloadMenssagem = this.selectedOption.text;
      }

      this.enviarMensagemComEnter();
      this.payloadMenssagem = "";
      this.closePayloadModal();
    },
    enviarMensagemComEnter() {
      const dfMessenger = document.querySelector("df-messenger");
      const shadowRoot = dfMessenger.shadowRoot;

      if (!shadowRoot) {
        return;
      }

      const slotElement = shadowRoot.querySelector("slot");
      if (!slotElement) {
        return;
      }

      const assignedElements = slotElement.assignedElements();
      if (!assignedElements || assignedElements.length === 0) {
        return;
      }

      const chatElement = assignedElements.find(
        (el) => el.tagName && el.tagName.toLowerCase() === "df-messenger-chat"
      );
      if (!chatElement) {
        return;
      }

      const chatShadowRoot = chatElement.shadowRoot;
      if (!chatShadowRoot) {
        return;
      }

      const userInput = chatShadowRoot.querySelector("df-messenger-user-input");
      if (!userInput) {
        return;
      }

      const userInputShadow = userInput.shadowRoot;
      if (!userInputShadow) {
        return;
      }

      const textarea = userInputShadow.querySelector("textarea.input-box");
      if (textarea) {
        textarea.value = this.payloadMenssagem;
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          which: 13,
          bubbles: true,
          cancelable: true,
        });

        textarea.dispatchEvent(event);
      }
    },

    finalize() {
      this.handleFinishAttendance();
      this.finalizeDialog = false;
      this.setShouldClearStorage(true);
      this.$router.push({ path: "/home" }).catch(() => {});
    },

    handleFinishAttendance,

    handleAlert,

    async handleVaraChange() {
      if (this.selectedOptions.varas) {
        try {
          // Reset balcões
          this.selectors.desks.items = [];
          this.selectors.desks.page = 0;
          this.selectors.desks.search = "";
          this.selectors.desks.count = 0;

          this.selectedOptions.desks = null;

          // Carrega os primeiros balcões
          await this.handleFetchDesks("", false);
        } catch (error) {
          console.error("Erro ao buscar:", error);
        }
      }
    },
    async handleCreateAttendance() {
      try {
        const response = await updateAttendance(this.attendance._id, {
          requester: {
            name: this.parametersCX.person.name,
            cpf: this.parametersCX.cpf,
          },
          attendanceFormat: "video",
          comarcaID: this.selectedOptions.comarca.value,
          varaID: this.selectedOptions.varas.value,
          deskID: this.selectedOptions.desks.value,
        });
        this.setAttendance(response.data);

        await this.handleRequestAttendance();
      } catch (error) {
        console.error("Erro ao criar atendimento:", error);
        this.handleAlert(
          "Erro ao criar atendimento. Tente novamente.",
          "error"
        );
      }
    },
    async handleRequestAttendance() {
      try {
        await this.requestAttendance({
          data: {
            protocol: this.attendance.protocol,
            deskID: this.selectedOptions?.desks?.value,
          },
          callback: (error, data) => {
            console.log("requestAttendance:data", data);

            if (error) {
              console.log("requestAttendance:error", error);
              throw new Error(
                "Falha ao tentar solicitar atendimento. Tente novamente"
              );
            }
            this.setAttendance(data);
            this.readMode = true;

            this.setInQueue(true);
            this.setMessages([]);
          },
        });

        await this.$nextTick();
        this.$router.push({ path: "/queue" }).catch(() => {});
      } catch (error) {
        console.error("Erro ao solicitar atendimento:", error);
        this.handleAlert(
          "Erro ao solicitar atendimento. Tente novamente.",
          "error"
        );
      }
    },

    handlePreSelection() {
      if (
        this.preSelection?.deskID &&
        this.preSelection?.subgroupID &&
        this.preSelection?.groupID
      ) {
        this.createAttendanceFromPreSelection();
      }
    },

    async createAttendanceFromPreSelection() {
      try {
        const payload = {
          requester: {
            name: this.parametersCX?.person?.name || "",
            cpf: this.parametersCX?.cpf || "",
          },
          attendanceFormat: "video",
          comarcaID: this.preSelection.groupID,
          varaID: this.preSelection.subgroupID,
          deskID: this.preSelection.deskID,
        };

        const response = await updateAttendance(this.attendance._id, payload);
        this.setAttendance(response.data);

        await this.requestAttendanceWithPreSelection();
      } catch (error) {
        console.error("Erro ao criar atendimento com preSelection:", error);
        this.handleAlert(
          "Erro ao criar atendimento automaticamente. Tente novamente.",
          "error"
        );
      }
    },

    async requestAttendanceWithPreSelection() {
      try {
        await this.requestAttendance({
          data: {
            protocol: this.attendance.protocol,
            deskID: this.preSelection.deskID,
          },
          callback: (error, data) => {
            console.log("requestAttendance:data", data);

            if (error) {
              console.log("requestAttendance:error", error);
              throw new Error(
                "Falha ao tentar solicitar atendimento. Tente novamente"
              );
            }
            this.setAttendance(data);
            this.readMode = true;

            this.setInQueue(true);
            this.setMessages([]);
          },
        });

        await this.$nextTick();
        this.$router.push({ path: "/queue" }).catch(() => {});
      } catch (error) {
        console.error("Erro ao solicitar atendimento:", error);
        this.handleAlert(
          "Erro ao solicitar atendimento. Tente novamente.",
          "error"
        );
      }
    },

    loadMoreComarcas() {
      this.selectors.groups.page++;
      this.handleFetchGroups(this.selectors.groups.search, true);
    },

    loadMoreVaras() {
      this.selectors.varas.page++;
      this.handleFetchVaras(this.selectors.varas.search, true);
    },

    loadMoreDesks() {
      this.selectors.desks.page++;
      this.handleFetchDesks(this.selectors.desks.search, true);
    },

    loadMoreCities() {
      this.selectors.cities.page++;
      this.handleFetchCities(this.selectors.cities.search, true);
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
